import { render } from "./slider.vue?vue&type=template&id=16c7bd74&scoped=true&bindings={\"imgs\":\"props\",\"images\":\"setup\",\"right\":\"setup\",\"left\":\"setup\",\"autoSlide\":\"setup\"}"
import script from "./slider.vue?vue&type=script&lang=js"
export * from "./slider.vue?vue&type=script&lang=js"

import "./slider.vue?vue&type=style&index=0&id=16c7bd74&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-16c7bd74"

export default script